import { format } from "date-fns";
import { es } from "date-fns/locale";
import { Link } from "react-router-dom";

/* eslint-disable react/prop-types */

const EventCard = ({ event }) => {
    const [year, month, day] = event.fecha.split("-");

    const localDate = new Date(
        Number(year),
        Number(month) - 1,
        Number(day)
    );

    const dayNumber = format(localDate, "dd", {
        locale: es,
    });

    const shortMonth = format(localDate, "MMM", {
        locale: es,
    })
        .replace(".", "")
        .toUpperCase();

    const fullDate = format(
        localDate,
        `d 'de' MMMM 'de' yyyy`,
        {
            locale: es,
        }
    );

    const eventTime = event.hora || event.horario;
    const eventUrl = event.eventUrl || `/eventos/${event.slug}`;
    const isExternalEvent = /^https?:\/\//.test(eventUrl);

    if (!event.slug) {
        return null;
    }

    const cardContent = (
        <article className="w-[300px] overflow-hidden rounded-2xl border border-zinc-800/90 bg-zinc-900/80 shadow-xl transition-all duration-300 hover:-translate-y-1 hover:border-zinc-600 hover:shadow-[0_22px_50px_rgba(0,0,0,0.45)]">
            <div className="relative h-[400px] w-full overflow-hidden">
                <img
                    src={event.img}
                    alt={event.nombre}
                    width="300"
                    height="400"
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/85 via-zinc-950/20 to-transparent" />

                <div className="absolute left-3 top-3 rounded-xl border border-white/20 bg-zinc-900/75 px-3 py-2 text-center backdrop-blur-md">
                    <p className="text-lg font-bold leading-none text-white">
                        {dayNumber}
                    </p>

                    <p className="text-[11px] tracking-[0.18em] text-rose-300">
                        {shortMonth}
                    </p>
                </div>

                <div className="absolute bottom-3 left-3 rounded-full border border-zinc-200/20 bg-zinc-900/80 px-3 py-1 text-xs text-zinc-100 backdrop-blur-sm">
                    {event.ubicacion || "Ubicación a confirmar"}
                </div>
            </div>

            <div className="px-3 py-4">
                <h3 className="truncate text-2xl font-semibold uppercase text-zinc-100">
                    {event.nombre}
                </h3>

                <p className="mt-2 text-sm text-zinc-300">
                    {fullDate}
                </p>

                {eventTime && (
                    <p className="mt-1 text-sm font-medium text-zinc-200">
                        {eventTime} hs
                    </p>
                )}

                <div className="mt-4 inline-block w-full rounded-xl bg-gradient-to-r from-zinc-800 to-zinc-900 px-4 py-2 text-center text-sm font-medium text-zinc-100 ring-1 ring-zinc-700 transition-colors group-hover:from-rose-900/60 group-hover:to-zinc-900 group-hover:ring-rose-400/40">
                    Ver entradas
                </div>
            </div>
        </article>
    );

    if (isExternalEvent) {
        return (
            <a
                href={eventUrl}
                className="group block"
            >
                {cardContent}
            </a>
        );
    }

    return (
        <Link
            to={eventUrl}
            className="group block"
        >
            {cardContent}
        </Link>
    );
};

export default EventCard;